import { h } from 'preact';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

import ArrowBack from '@mui/icons-material/ArrowBack';

import styles from '../../components/global.css';
import LazyPercentileChart from '../../components/percentileChart/lazyPercentileChart.jsx';
import { IssueTable } from './_common.jsx';
import LazyVariations from '../../components/variations/lazyVariations.jsx';
import LazyBarVariation from '../../components/barVariation/lazyBarVariation.jsx';
import LazyLcpIssueRecord from '../../components/lcpIssueRecord/lazyLcpIssueRecord.jsx';
import { PharosLink } from '../../components/router/router.jsx';
import LazyRpmSingleMetricCard from '../../components/rpmSingleMetricCard/lazyRpmSingleMetricCard.jsx';

export default function LazyLcpUrlIssueDetail(props) {
  const { propertyId } = props;

  return (
    <>
      <Paper className={`${styles.originArea} ${styles.issueTimings}`}>
        <Typography variant="h5">
          <PharosLink href={propertyId ? `/property/${propertyId}/lcp` : ''}>
            <Button color="secondary">
              <ArrowBack className={styles.reportAnchor} />
            </Button>
          </PharosLink>
          <Skeleton
            variant="text"
            width={200}
            height={36}
            sx={{ display: 'inline-block' }}
          />
        </Typography>
      </Paper>

      <Paper className={`${styles.originArea} ${styles.issueTimings}`}>
        <Typography variant="h6">TTFB</Typography>
        <LazyPercentileChart />
      </Paper>

      <Paper className={`${styles.originArea} ${styles.queryVariationsArea}`}>
        <Typography variant="h5">Request variations</Typography>
        <LazyBarVariation />
      </Paper>

      <div className={`${styles.rpmReportArea}`}>
        <LazyRpmSingleMetricCard />
      </div>

      <Paper className={`${styles.originArea}`}>
        <Typography variant="h5">Variations</Typography>
        <LazyVariations />
      </Paper>

      <Paper className={`${styles.originArea}`}>
        <div className={styles.urlListHeader}>
          <Typography variant="h5">Found issues</Typography>
        </div>
        <IssueTable>
          {Array(15)
            .fill(null)
            .map((_, index) => (
              <LazyLcpIssueRecord key={index} />
            ))}
        </IssueTable>
      </Paper>
    </>
  );
}
